import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

/**
 * DeliveryItemAPI - API controller for delivery list items
 * TODO: Implement methods when API is ready
 */
export default class DeliveryItemAPI {
    private static buildRequestAttributes(itemData: any): Record<string, any> {
        const attributes = { ...itemData };

        // Temporarily do not send contactPersonName until the BE supports it on POST/PATCH.
        delete attributes.contactPersonName;

        return attributes;
    }

    /**
     * Get all items for a specific delivery
     */
    public static async getByDeliveryId(deliveryId: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.deliveryItems.getByDeliveryId(deliveryId));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get delivery items filtered by days and delivery region
     */
    public static async getByFilters(days: string[], deliveryRegion: string | null): Promise<AxiosResponse> {
        const params = new URLSearchParams();

        days.forEach((day) => params.append('days[]', day));

        if (deliveryRegion) {
            params.append('deliveryRegion', deliveryRegion);
        }

        const query = params.toString();
        const cleanQuery = query ? `?${query}` : '';

        try {
            const response = await ApiController.get(ApiRoutes.deliveryItems.getByFilters(cleanQuery));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Create a new delivery item
     * TODO: Implement when API specification is finalized
     */
    public static async create(deliveryId: string, itemData: any): Promise<AxiosResponse> {
        const request = {
            data: {
                type: 'delivery_list_items',
                attributes: DeliveryItemAPI.buildRequestAttributes(itemData),
                relationships: {
                    delivery: {
                        data: {
                            type: 'deliveries',
                            id: deliveryId,
                        },
                    },
                },
            },
        };

        try {
            const response = await ApiController.post(ApiRoutes.deliveryItems.create, request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Update an existing delivery item
     * TODO: Implement when API specification is finalized
     */
    public static async update(id: string, itemData: any): Promise<AxiosResponse> {
        const request = {
            data: {
                type: 'delivery_list_items',
                id,
                attributes: DeliveryItemAPI.buildRequestAttributes(itemData),
            },
        };

        try {
            const response = await ApiController.patch(ApiRoutes.deliveryItems.update(id), request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Delete a delivery item
     */
    public static async delete(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.delete(ApiRoutes.deliveryItems.delete(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
